import { ideaConverter } from "./converter";

export const updateIdeaApi = (id, values) => (dispatch, getState, { api }) => {
  return api.put(`/private/idea/idea/${id}`, ideaConverter.forBE(values));
};
